import { Button, Tooltip } from "@mui/material";
import React from "react";

export const EthGaseComp = ({ ethGasData }) => {
  return (
    <div className="mCard grayCard mb-3">
      <div className="title d-flex jc-sb">
        Eth Gas
        <Tooltip
          title="Gwei is a small unit of ETH used to calculate Ethereum transaction (gas) fees. 1 Gwei = 0.000000001 ETH."
          placement="top"
        >
          <i className="fa-solid fa-circle-info" style={{ cursor: "help" }}></i>
        </Tooltip>
      </div>
      <div className="ethGasRow">
        <div className="dCol">
          <div className="name">Slow</div>
          <div className="val">{ethGasData?.slow?.gwei || 0} Gwei</div>
          <div className="name">{ethGasData?.slow?.estTime}</div>
        </div>
        <div className="dCol">
          <div className="name">Standard</div>
          <div className="val">{ethGasData?.standard?.gwei || 0} Gwei</div>
          <div className="name">{ethGasData?.standard?.estTime}</div>
        </div>
        <div className="dCol">
          <div className="name">Fast</div>
          <div className="val">{ethGasData?.fast?.gwei || 0} Gwei</div>
          <div className="name">{ethGasData?.fast?.estTime}</div>
        </div>
      </div>
    </div>
  );
};
